import {useMatch, useResolvedPath} from '@github-ui/react-router'
import {type ActionListLinkItemProps, NavList} from '@primer/react'
import type {ComponentProps} from 'react'

import {NavLinkWithActiveClassName} from './nav-link-with-active-class-name'

type NavLinkActionListItemProps = ActionListLinkItemProps &
  ComponentProps<typeof NavLinkWithActiveClassName> & {ref?: React.Ref<HTMLAnchorElement>}

export function NavLinkActionListItem({ref, to, children, isActive, ...props}: NavLinkActionListItemProps) {
  const resolved = useResolvedPath(to)
  const isCurrent = useMatch({path: resolved.pathname, end: true})
  return (
    <NavList.Item
      aria-current={isActive || isCurrent ? 'page' : false}
      as={NavLinkWithActiveClassName}
      {...props}
      to={to}
      ref={ref}
    >
      {children}
    </NavList.Item>
  )
}
